import React from 'react'
import styles from './MetricsPicker.scss'
import {metricsSpec as tripMetricsSpec, routeMetricsSpec} from 'common/Metrics'
import {BlockOverlay} from '../../BlockOverlay'
import {Button} from 'common/Button'
import {List} from 'immutable'

const MAX_METRICS = 5
const MIN_METRICS = 2

export class MetricsPicker extends React.Component {
  constructor (props) {
    super(props)
    this.state = {selected: new List(props.selected)}
  }

  confirmSelection = () => {
    const {onConfirm} = this.props
    const {selected} = this.state
    onConfirm(selected.toJS())
  }

  toggle = (metric) => {
    const {selected} = this.state
    if (selected.includes(metric)) {
      this.setState({selected: selected.filterNot(v => v === metric)})
    } else {
      if (selected.size >= MAX_METRICS + 1) { return }
      this.setState({selected: selected.push(metric)})
    }
  }

  render () {
    const {onClose, objectType} = this.props
    const {selected} = this.state

    const tooMany = selected.size > MAX_METRICS
    const tooFew = selected.size < MIN_METRICS
    const disableButton = tooMany || tooFew

    const metricsSpec = objectType && objectType === 'route'
      ? routeMetricsSpec
      : tripMetricsSpec

    return (
      <BlockOverlay onClose={onClose}>
        <div className={styles.MetricsPicker}>
          <h1>Select Metrics</h1>
          <p>Pick the metrics you want displayed at the bottom of the map:</p>
          <div className={styles.list}>
            {metricsSpec.map((v, k) => (
              <div className={styles.listItem} key={k}>
                <label>
                  <input type='checkbox' checked={selected.includes(k)} onChange={() => this.toggle(k)} /> {v.label}
                </label>
              </div>
            )).toIndexedSeq().toJS()}
          </div>
          {tooMany && <p className={styles.infoMessage}>You have too many metrics selected! Please select between 3 and 5 metrics to display.</p>}
          {tooFew && <p className={styles.infoMessage}>You have too few metrics selected! Please select between 3 and 5 metrics to display.</p>}
          <Button type='default' onClick={!disableButton && this.confirmSelection} disabled={disableButton}>save</Button>
        </div>
      </BlockOverlay>
    )
  }
}
